import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';
import LabeledInput from '../../../controls/LabeledInput';
import LabeledSelect from '../../../controls/LabeledSelect';

const EVENT_TYPE_OPTIONS = [
    { key: 'FOOTBALL', value: 'Футбол' },
    { key: 'VOLLEYBALL', value: 'Волейбол' }
];

function defaultStart() {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 30);
    return now.toISOString().slice(0, 16);
}

function toLocalInput(dateStr) {
    const d = new Date(dateStr);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Модалка создания/редактирования спортивного события. С event → режим редактирования.
export default function CreateSportModal({ teams, event, onSubmit, onClose }) {
    const [form, setForm] = useState(() => (event ? {
        eventType: event.eventType,
        team1Id: String(event.team1.id),
        team2Id: String(event.team2.id),
        startTime: toLocalInput(event.startTime)
    } : { eventType: 'VOLLEYBALL', team1Id: '', team2Id: '', startTime: defaultStart() }));

    const teamOptions = useMemo(() => teams.map(t => ({ key: t.id, value: t.name })), [teams]);
    const team1Options = teamOptions.filter(t => String(t.key) !== String(form.team2Id));
    const team2Options = teamOptions.filter(t => String(t.key) !== String(form.team1Id));

    const set = (field) => (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));
    const valid = form.team1Id && form.team2Id && form.team1Id !== form.team2Id && form.startTime;

    const submit = async () => {
        if (!valid) return;
        try {
            await onSubmit({
                team1Id: Number(form.team1Id),
                team2Id: Number(form.team2Id),
                eventType: form.eventType,
                startTime: form.startTime
            });
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };

    return (
        <Modal
            open
            kicker="Спортивное событие"
            title={event ? 'Изменить событие' : 'Создать событие'}
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={submit} disabled={!valid}>{event ? 'Сохранить' : 'Создать'}</button>
                </>
            )}
        >
            {event && (
                <div className="bt-editnote">
                    Смена команд или типа вернёт все активные ставки игрокам (с уведомлением). Перенос времени ставки не затрагивает.
                </div>
            )}
            <LabeledSelect label="Тип события" value={form.eventType} onChange={set('eventType')} options={EVENT_TYPE_OPTIONS} />
            <LabeledSelect label="Команда 1" value={form.team1Id} onChange={set('team1Id')} options={team1Options} placeholder="Выберите команду" />
            <LabeledSelect label="Команда 2" value={form.team2Id} onChange={set('team2Id')} options={team2Options} placeholder="Выберите команду" />
            <LabeledInput label="Время начала" type="datetime-local" value={form.startTime} onChange={set('startTime')} />
        </Modal>
    );
}

CreateSportModal.propTypes = {
    teams: PropTypes.array.isRequired,
    event: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

CreateSportModal.defaultProps = { event: null };
